// This is api.js
// important links: 
// https://site.financialmodelingprep.com/developer/docs/historical-stock-data-free-api/?direct=true

// import axios from "axios";
// const API_KEY = process.env.REACT_APP_API_KEY;
// BASE_URL for ratios (for the metrics)
// https://site.financialmodelingprep.com/developer/docs/daily-chart-charts
// const RATIOS_URL = "https://financialmodelingprep.com/api/v3/ratios/";
                                                                          // const RATIOS_URL = "google.com";

// BASE_URL for historical data (for the chart)
// const HISTORICAL_URL = "https://financialmodelingprep.com/api/v3/historical-price-full/";
                                                                          // const HISTORICAL_URL = "google.com";

  // ******* WORKING API FUNCTION  *******                                                                
// Fetch metrics for a stock symbol
// export const fetchMetrics = async (symbol) => {
//   try {
//     const response = await axios.get(`${RATIOS_URL}${symbol}?apikey=${API_KEY}`);
//     console.log("API Response:", response.data); // Log the full response
//     return response.data[0]; // Get the latest data for ratios
//   } catch (error) {
//     console.error("Error fetching metrics data:", error);
//     return null;
//   }
// };

// // Fetch historical price data for a stock symbol (for the chart)
// export const fetchHistoricalData = async (symbol) => {
//   try {
//     const response = await axios.get(`${HISTORICAL_URL}${symbol}?timeseries=30&apikey=${API_KEY}`);
//     console.log("***Historical Data Response:", response.data); // Log the historical data response
//     return response.data.historical || []; // Return the historical data array or an empty array

//   } catch (error) {
//     console.error("Error fetching historical data:", error);
//     return []; // Return an empty array if there's an error
//   }
// };


  // ^^^^^^^ WORKING API FUNCTION  ^^^^^  

   export const createStripePaymentLink = async (idToken) => {
       const res = await fetch('https://1azyop0jo8.execute-api.eu-west-2.amazonaws.com/dev/create-payment-link', {
         method: 'POST',
         headers: {
           Authorization: `Bearer ${idToken}`,
         },
       });
       if (!res.ok) throw new Error('Failed to create Stripe payment link');
       const { url } = await res.json();
       return url;
     };

  // Mock data for ratios
export const STOCK_SEARCH_LIST = {
//   "AAPL": {},
//   "GOOGL": {},
//   "TSLA": {}, 
//   "AMZN": {}, 
//  "MSFT": {}, 
//  "NVDA": {}

"AAPL": {},
"GOOGL": {},
"TSLA": {}, 
"AMZN": {}, 
"MSFT": {}, 
"NVDA": {},
"META": {},
"NFLX": {},
"CRM": {},
"ADBE": {},


  
};

// New function that returns mock data
// export const fetchMetrics = async (symbol) => {
//   try {
//     // Simulate network delay
//     await new Promise(resolve => setTimeout(resolve, 300));
    
//     // Check if the symbol exists in our mock data
//     if (STOCK_SEARCH_LIST[symbol]) {
//       console.log("Mock API Response:", [STOCK_SEARCH_LIST[symbol]]); // Log similar to the original
//       return STOCK_SEARCH_LIST[symbol]; // Return the mock data
//     } else {
//       // If symbol not found in mock data
//       console.error("Symbol not found in mock data:", symbol);
//       return null;
//     }
//   } catch (error) {
//     console.error("Error fetching mock metrics data:", error);
//     return null;
//   }
// };


// Mock data for historical prices from api.js
// const MOCK_HISTORICAL_DATA = {
//   "AAPL": {
//     "symbol": "AAPL",
//     "historical": [
//       {
//         "date": "2025-05-16",
//         "open": 212.32,
//         "high": 212.57,
//         "low": 209.77,
//         "close": 211.71,
//         "adjClose": 211.71,
//         "volume": 35514606,
//         "unadjustedVolume": 35514606,
//         "change": -0.61,
//         "changePercent": -0.28730219,
//         "vwap": 211.35,
//         "label": "May 16, 25",
//         "changeOverTime": -0.0028730219
//       },
//       {
//         "date": "2025-05-15",
//         "open": 210.95,
//         "high": 212.96,
//         "low": 209.54,
//         "close": 211.45,
//         "adjClose": 211.45,
//         "volume": 43864052,
//         "unadjustedVolume": 43864052,
//         "change": 0.5,
//         "changePercent": 0.23702,
//         "vwap": 211.225,
//         "label": "May 15, 25",
//         "changeOverTime": 0.0023702
//       },
//       {
//         "date": "2025-05-14",
//         "open": 212.43,
//         "high": 213.94,
//         "low": 210.58,
//         "close": 212.33,
//         "adjClose": 212.33,
//         "volume": 49325825,
//         "unadjustedVolume": 49325825,
//         "change": -0.1,
//         "changePercent": -0.04707433,
//         "vwap": 212.32,
//         "label": "May 14, 25",
//         "changeOverTime": -0.0004707433
//       },
//       {
//         "date": "2025-05-13",
//         "open": 210.43,
//         "high": 213.4,
//         "low": 209,
//         "close": 212.93,
//         "adjClose": 212.93,
//         "volume": 51909332,
//         "unadjustedVolume": 51909332,
//         "change": 2.5,
//         "changePercent": 1.19,
//         "vwap": 211.44,
//         "label": "May 13, 25",
//         "changeOverTime": 0.0119
//       },
//       {
//         "date": "2025-05-12",
//         "open": 210.97,
//         "high": 211.27,
//         "low": 206.75,
//         "close": 210.79,
//         "adjClose": 210.79,
//         "volume": 63775814,
//         "unadjustedVolume": 63775814,
//         "change": -0.18,
//         "changePercent": -0.08532019,
//         "vwap": 209.945,
//         "label": "May 12, 25",
//         "changeOverTime": -0.0008532019
//       },
//       {
//         "date": "2025-05-09",
//         "open": 199,
//         "high": 200.54,
//         "low": 197.54,
//         "close": 198.53,
//         "adjClose": 198.27,
//         "volume": 36453923,
//         "unadjustedVolume": 36453923,
//         "change": -0.47,
//         "changePercent": -0.23618,
//         "vwap": 198.9025,
//         "label": "May 09, 25",
//         "changeOverTime": -0.0023618
//       },
//       {
//         "date": "2025-05-08",
//         "open": 197.72,
//         "high": 200.05,
//         "low": 194.68,
//         "close": 197.49,
//         "adjClose": 197.23,
//         "volume": 50478900,
//         "unadjustedVolume": 50478900,
//         "change": -0.23,
//         "changePercent": -0.11633,
//         "vwap": 197.485,
//         "label": "May 08, 25",
//         "changeOverTime": -0.0011633
//       },
//       {
//         "date": "2025-05-07",
//         "open": 199.17,
//         "high": 199.44,
//         "low": 193.25,
//         "close": 196.25,
//         "adjClose": 195.99,
//         "volume": 68616943,
//         "unadjustedVolume": 68616943,
//         "change": -2.92,
//         "changePercent": -1.47,
//         "vwap": 197.0275,
//         "label": "May 07, 25",
//         "changeOverTime": -0.0147
//       },
//       {
//         "date": "2025-05-06",
//         "open": 198.21,
//         "high": 200.65,
//         "low": 197.02,
//         "close": 198.51,
//         "adjClose": 198.25,
//         "volume": 51216500,
//         "unadjustedVolume": 51216500,
//         "change": 0.3,
//         "changePercent": 0.15135,
//         "vwap": 198.5975,
//         "label": "May 06, 25",
//         "changeOverTime": 0.0015135
//       },
//       {
//         "date": "2025-05-05",
//         "open": 203.1,
//         "high": 204.1,
//         "low": 198.21,
//         "close": 198.89,
//         "adjClose": 198.63,
//         "volume": 69018500,
//         "unadjustedVolume": 69018500,
//         "change": -4.21,
//         "changePercent": -2.07,
//         "vwap": 201.075,
//         "label": "May 05, 25",
//         "changeOverTime": -0.0207
//       },
//       {
//         "date": "2025-05-02",
//         "open": 206.09,
//         "high": 206.99,
//         "low": 202.16,
//         "close": 205.35,
//         "adjClose": 205.08,
//         "volume": 101010621,
//         "unadjustedVolume": 101010621,
//         "change": -0.74,
//         "changePercent": -0.35907,
//         "vwap": 205.1475,
//         "label": "May 02, 25",
//         "changeOverTime": -0.0035907
//       },
//       {
//         "date": "2025-05-01",
//         "open": 209.08,
//         "high": 214.56,
//         "low": 208.9,
//         "close": 213.32,
//         "adjClose": 213.04,
//         "volume": 57365700,
//         "unadjustedVolume": 57365700,
//         "change": 4.24,
//         "changePercent": 2.03,
//         "vwap": 211.465,
//         "label": "May 01, 25",
//         "changeOverTime": 0.0203
//       }
//     ]
//   },
//   "TSLA": {
//     "symbol": "TSLA",
//     "historical": [
//       {
//         "date": "2025-05-16",
//         "open": 346.065,
//         "high": 351.62,
//         "low": 342.33,
//         "close": 348.41,
//         "adjClose": 348.41,
//         "volume": 73840859,
//         "unadjustedVolume": 73840859,
//         "change": 2.35,
//         "changePercent": 0.67761837,
//         "vwap": 347.45,
//         "label": "May 16, 25",
//         "changeOverTime": 0.0067761837
//       },
//       {
//         "date": "2025-05-15",
//         "open": 340.34,
//         "high": 346.14,
//         "low": 334.72,
//         "close": 342.82,
//         "adjClose": 342.82,
//         "volume": 97621597,
//         "unadjustedVolume": 97621597,
//         "change": 2.48,
//         "changePercent": 0.72868,
//         "vwap": 341.005,
//         "label": "May 15, 25",
//         "changeOverTime": 0.0072868
//       },
//       {
//         "date": "2025-05-14",
//         "open": 342.5,
//         "high": 350,
//         "low": 337,
//         "close": 347.68,
//         "adjClose": 347.68,
//         "volume": 136997300,
//         "unadjustedVolume": 136997300,
//         "change": 5.18,
//         "changePercent": 1.51,
//         "vwap": 344.295,
//         "label": "May 14, 25",
//         "changeOverTime": 0.0151
//       },
//       {
//         "date": "2025-05-13",
//         "open": 320,
//         "high": 337.59,
//         "low": 316.8,
//         "close": 334.07,
//         "adjClose": 334.07,
//         "volume": 136992600,
//         "unadjustedVolume": 136992600,
//         "change": 14.07,
//         "changePercent": 4.4,
//         "vwap": 327.115,
//         "label": "May 13, 25",
//         "changeOverTime": 0.044
//       },
//       {
//         "date": "2025-05-12",
//         "open": 321.99,
//         "high": 322.21,
//         "low": 311.5,
//         "close": 318.38,
//         "adjClose": 318.38,
//         "volume": 112826700,
//         "unadjustedVolume": 112826700,
//         "change": -3.61,
//         "changePercent": -1.12,
//         "vwap": 318.52,
//         "label": "May 12, 25",
//         "changeOverTime": -0.0112
//       },
//       {
//         "date": "2025-05-09",
//         "open": 290.21,
//         "high": 307.04,
//         "low": 290,
//         "close": 298.26,
//         "adjClose": 298.26,
//         "volume": 132387835,
//         "unadjustedVolume": 132387835,
//         "change": 8.05,
//         "changePercent": 2.77,
//         "vwap": 296.3775,
//         "label": "May 09, 25",
//         "changeOverTime": 0.0277
//       },
//       {
//         "date": "2025-05-08",
//         "open": 279.63,
//         "high": 289.8,
//         "low": 279.41,
//         "close": 284.82,
//         "adjClose": 284.82,
//         "volume": 97539448,
//         "unadjustedVolume": 97539448,
//         "change": 5.19,
//         "changePercent": 1.86,
//         "vwap": 283.415,
//         "label": "May 08, 25",
//         "changeOverTime": 0.0186
//       },
//       {
//         "date": "2025-05-07",
//         "open": 276.88,
//         "high": 277.92,
//         "low": 271,
//         "close": 276.22,
//         "adjClose": 276.22,
//         "volume": 71882408,
//         "unadjustedVolume": 71882408,
//         "change": -0.66,
//         "changePercent": -0.23837,
//         "vwap": 275.505,
//         "label": "May 07, 25",
//         "changeOverTime": -0.0023837
//       },
//       {
//         "date": "2025-05-06",
//         "open": 273.11,
//         "high": 277.73,
//         "low": 271.35,
//         "close": 275.35,
//         "adjClose": 275.35,
//         "volume": 76715800,
//         "unadjustedVolume": 76715800,
//         "change": 2.25,
//         "changePercent": 0.82018,
//         "vwap": 274.385,
//         "label": "May 06, 25",
//         "changeOverTime": 0.0082018
//       },
//       {
//         "date": "2025-05-05",
//         "open": 284.57,
//         "high": 284.85,
//         "low": 274.4,
//         "close": 280.26,
//         "adjClose": 280.26,
//         "volume": 94618900,
//         "unadjustedVolume": 94618900,
//         "change": -4.31,
//         "changePercent": -1.51,
//         "vwap": 281.02,
//         "label": "May 05, 25",
//         "changeOverTime": -0.0151
//       },
//       {
//         "date": "2025-05-02",
//         "open": 284.9,
//         "high": 294.78,
//         "low": 279.81,
//         "close": 287.21,
//         "adjClose": 287.21,
//         "volume": 114454700,
//         "unadjustedVolume": 114454700,
//         "change": 2.31,
//         "changePercent": 0.81081,
//         "vwap": 286.675,
//         "label": "May 02, 25",
//         "changeOverTime": 0.0081081
//       },
//       {
//         "date": "2025-05-01",
//         "open": 280.01,
//         "high": 290.87,
//         "low": 279.81,
//         "close": 280.52,
//         "adjClose": 280.52,
//         "volume": 99659000,
//         "unadjustedVolume": 99659000,
//         "change": 0.51,
//         "changePercent": 0.18214,
//         "vwap": 282.8025,
//         "label": "May 01, 25",
//         "changeOverTime": 0.0018214
//       }
//     ]
//   },
//   "GOOGL": {
//     "symbol": "GOOGL",
//     "historical": [
//       {
//         "date": "2025-05-16",
//         "open": 168.955,
//         "high": 170.65,
//         "low": 166.95,
//         "close": 168.05,
//         "adjClose": 168.05,
//         "volume": 27305278,
//         "unadjustedVolume": 27305278,
//         "change": -0.905,
//         "changePercent": -0.53564559,
//         "vwap": 168.55,
//         "label": "May 16, 25",
//         "changeOverTime": -0.0053564559
//       },
//       {
//         "date": "2025-05-15",
//         "open": 167.14,
//         "high": 167.51,
//         "low": 163.84,
//         "close": 165.4,
//         "adjClose": 165.4,
//         "volume": 22654210,
//         "unadjustedVolume": 22654210,
//         "change": -1.74,
//         "changePercent": -1.04,
//         "vwap": 165.9725,
//         "label": "May 15, 25",
//         "changeOverTime": -0.0104
//       },
//       {
//         "date": "2025-05-14",
//         "open": 161.31,
//         "high": 168.34,
//         "low": 160.93,
//         "close": 166.81,
//         "adjClose": 166.81,
//         "volume": 31769209,
//         "unadjustedVolume": 31769209,
//         "change": 5.5,
//         "changePercent": 3.41,
//         "vwap": 164.3475,
//         "label": "May 14, 25",
//         "changeOverTime": 0.0341
//       },
//       {
//         "date": "2025-05-13",
//         "open": 159.92,
//         "high": 162.06,
//         "low": 157.58,
//         "close": 160.89,
//         "adjClose": 160.89,
//         "volume": 24944300,
//         "unadjustedVolume": 24944300,
//         "change": 0.97,
//         "changePercent": 0.60655,
//         "vwap": 160.1125,
//         "label": "May 13, 25",
//         "changeOverTime": 0.0060655
//       },
//       {
//         "date": "2025-05-12",
//         "open": 159.1,
//         "high": 160.44,
//         "low": 157.89,
//         "close": 159.58,
//         "adjClose": 159.58,
//         "volume": 31884901,
//         "unadjustedVolume": 31884901,
//         "change": 0.48,
//         "changePercent": 0.3017,
//         "vwap": 159.2525,
//         "label": "May 12, 25",
//         "changeOverTime": 0.003017
//       },
//       {
//         "date": "2025-05-09",
//         "open": 155.55,
//         "high": 156.43,
//         "low": 153.83,
//         "close": 154.38,
//         "adjClose": 154.38,
//         "volume": 22871035,
//         "unadjustedVolume": 22871035,
//         "change": -1.17,
//         "changePercent": -0.75217,
//         "vwap": 155.0475,
//         "label": "May 09, 25",
//         "changeOverTime": -0.0075217
//       },
//       {
//         "date": "2025-05-08",
//         "open": 155.92,
//         "high": 157.41,
//         "low": 154.1,
//         "close": 155.75,
//         "adjClose": 155.75,
//         "volume": 38387507,
//         "unadjustedVolume": 38387507,
//         "change": -0.17,
//         "changePercent": -0.10903,
//         "vwap": 155.795,
//         "label": "May 08, 25",
//         "changeOverTime": -0.0010903
//       },
//       {
//         "date": "2025-05-07",
//         "open": 166.07,
//         "high": 166.99,
//         "low": 149.49,
//         "close": 152.8,
//         "adjClose": 152.8,
//         "volume": 78900429,
//         "unadjustedVolume": 78900429,
//         "change": -13.27,
//         "changePercent": -7.99,
//         "vwap": 158.8375,
//         "label": "May 07, 25",
//         "changeOverTime": -0.0799
//       },
//       {
//         "date": "2025-05-06",
//         "open": 163.96,
//         "high": 166.74,
//         "low": 163.13,
//         "close": 165.2,
//         "adjClose": 165.2,
//         "volume": 10691949,
//         "unadjustedVolume": 10691949,
//         "change": 1.24,
//         "changePercent": 0.75628,
//         "vwap": 164.7575,
//         "label": "May 06, 25",
//         "changeOverTime": 0.0075628
//       },
//       {
//         "date": "2025-05-05",
//         "open": 164.52,
//         "high": 167.1,
//         "low": 164.47,
//         "close": 166.05,
//         "adjClose": 166.05,
//         "volume": 15309343,
//         "unadjustedVolume": 15309343,
//         "change": 1.54,
//         "changePercent": 0.92998,
//         "vwap": 165.535,
//         "label": "May 05, 25",
//         "changeOverTime": 0.0092998
//       },
//       {
//         "date": "2025-05-02",
//         "open": 164.96,
//         "high": 166.7,
//         "low": 163.66,
//         "close": 165.81,
//         "adjClose": 165.81,
//         "volume": 16844937,
//         "unadjustedVolume": 16844937,
//         "change": 0.855,
//         "changePercent": 0.51528,
//         "vwap": 165.2825,
//         "label": "May 02, 25",
//         "changeOverTime": 0.0051528
//       },
//       {
//         "date": "2025-05-01",
//         "open": 162.52,
//         "high": 163.94,
//         "low": 160.93,
//         "close": 162.79,
//         "adjClose": 162.79,
//         "volume": 21904300,
//         "unadjustedVolume": 21904300,
//         "change": 0.27,
//         "changePercent": 0.16613,
//         "vwap": 162.545,
//         "label": "May 01, 25",
//         "changeOverTime": 0.0016613
//       }
//     ]
//   },
//   "MSFT": {
//     "symbol": "MSFT",
//     "historical": [
//       {
//         "date": "2025-05-16",
//         "open": 452.355,
//         "high": 453.26,
//         "low": 448.7369,
//         "close": 453.08,
//         "adjClose": 453.08,
//         "volume": 13890263,
//         "unadjustedVolume": 13890263,
//         "change": 0.725,
//         "changePercent": 0.16027235,
//         "vwap": 451.69,
//         "label": "May 16, 25",
//         "changeOverTime": 0.0016027235
//       },
//       {
//         "date": "2025-05-15",
//         "open": 450.77,
//         "high": 456.19,
//         "low": 450.43,
//         "close": 453.13,
//         "adjClose": 453.13,
//         "volume": 21091372,
//         "unadjustedVolume": 21091372,
//         "change": 2.37,
//         "changePercent": 0.52355,
//         "vwap": 452.63,
//         "label": "May 15, 25",
//         "changeOverTime": 0.0052355
//       },
//       {
//         "date": "2025-05-14",
//         "open": 448.14,
//         "high": 453.9,
//         "low": 448.14,
//         "close": 452.94,
//         "adjClose": 452.94,
//         "volume": 19902800,
//         "unadjustedVolume": 19902800,
//         "change": 4.8,
//         "changePercent": 1.07,
//         "vwap": 450.78,
//         "label": "May 14, 25",
//         "changeOverTime": 0.0107
//       },
//       {
//         "date": "2025-05-13",
//         "open": 447.78,
//         "high": 450.67,
//         "low": 445.36,
//         "close": 449.14,
//         "adjClose": 448.32,
//         "volume": 23618819,
//         "unadjustedVolume": 23618819,
//         "change": 1.36,
//         "changePercent": 0.30372,
//         "vwap": 448.2375,
//         "label": "May 13, 25",
//         "changeOverTime": 0.0030372
//       },
//       {
//         "date": "2025-05-12",
//         "open": 445.94,
//         "high": 449.37,
//         "low": 439.78,
//         "close": 449.26,
//         "adjClose": 448.44,
//         "volume": 22821935,
//         "unadjustedVolume": 22821935,
//         "change": 3.32,
//         "changePercent": 0.74449,
//         "vwap": 446.0875,
//         "label": "May 12, 25",
//         "changeOverTime": 0.0074449
//       },
//       {
//         "date": "2025-05-09",
//         "open": 440,
//         "high": 440.74,
//         "low": 435.88,
//         "close": 438.73,
//         "adjClose": 437.93,
//         "volume": 15324233,
//         "unadjustedVolume": 15324233,
//         "change": -1.27,
//         "changePercent": -0.28864,
//         "vwap": 438.8375,
//         "label": "May 09, 25",
//         "changeOverTime": -0.0028864
//       },
//       {
//         "date": "2025-05-08",
//         "open": 437.93,
//         "high": 443.67,
//         "low": 435.66,
//         "close": 438.17,
//         "adjClose": 437.37,
//         "volume": 23491330,
//         "unadjustedVolume": 23491330,
//         "change": 0.24,
//         "changePercent": 0.05480328,
//         "vwap": 438.8575,
//         "label": "May 08, 25",
//         "changeOverTime": 0.0005480328
//       },
//       {
//         "date": "2025-05-07",
//         "open": 433.84,
//         "high": 438.12,
//         "low": 431.11,
//         "close": 433.35,
//         "adjClose": 432.56,
//         "volume": 23307241,
//         "unadjustedVolume": 23307241,
//         "change": -0.49,
//         "changePercent": -0.11294,
//         "vwap": 434.105,
//         "label": "May 07, 25",
//         "changeOverTime": -0.0011294
//       },
//       {
//         "date": "2025-05-06",
//         "open": 432.2,
//         "high": 437.73,
//         "low": 431.17,
//         "close": 433.31,
//         "adjClose": 432.52,
//         "volume": 15104204,
//         "unadjustedVolume": 15104204,
//         "change": 1.11,
//         "changePercent": 0.25683,
//         "vwap": 433.6025,
//         "label": "May 06, 25",
//         "changeOverTime": 0.0025683
//       },
//       {
//         "date": "2025-05-05",
//         "open": 432.87,
//         "high": 439.5,
//         "low": 432.11,
//         "close": 436.17,
//         "adjClose": 435.37,
//         "volume": 20136100,
//         "unadjustedVolume": 20136100,
//         "change": 3.3,
//         "changePercent": 0.76235,
//         "vwap": 435.1625,
//         "label": "May 05, 25",
//         "changeOverTime": 0.0076235
//       },
//       {
//         "date": "2025-05-02",
//         "open": 431.74,
//         "high": 439.44,
//         "low": 429.99,
//         "close": 435.28,
//         "adjClose": 434.48,
//         "volume": 30757434,
//         "unadjustedVolume": 30757434,
//         "change": 3.54,
//         "changePercent": 0.81994,
//         "vwap": 434.1125,
//         "label": "May 02, 25",
//         "changeOverTime": 0.0081994
//       },
//       {
//         "date": "2025-05-01",
//         "open": 431.11,
//         "high": 436.99,
//         "low": 424.9,
//         "close": 425.4,
//         "adjClose": 424.62,
//         "volume": 58938100,
//         "unadjustedVolume": 58938100,
//         "change": -5.71,
//         "changePercent": -1.32,
//         "vwap": 429.6,
//         "label": "May 01, 25",
//         "changeOverTime": -0.0132
//       }
//     ]
//   },
//   "AMZN": {
//     "symbol": "AMZN",
//     "historical": [
//       {
//         "date": "2025-05-16",
//         "open": 206.85,
//         "high": 206.85,
//         "low": 204.374,
//         "close": 205.17,
//         "adjClose": 205.17,
//         "volume": 28727612,
//         "unadjustedVolume": 28727612,
//         "change": -1.68,
//         "changePercent": -0.81218274,
//         "vwap": 205.46,
//         "label": "May 16, 25",
//         "changeOverTime": -0.0081218274
//       },
//       {
//         "date": "2025-05-15",
//         "open": 206.45,
//         "high": 206.88,
//         "low": 202.67,
//         "close": 205.17,
//         "adjClose": 205.17,
//         "volume": 63993121,
//         "unadjustedVolume": 63993121,
//         "change": -1.28,
//         "changePercent": -0.62,
//         "vwap": 205.2925,
//         "label": "May 15, 25",
//         "changeOverTime": -0.0062
//       },
//       {
//         "date": "2025-05-14",
//         "open": 211.45,
//         "high": 211.93,
//         "low": 208.85,
//         "close": 210.25,
//         "adjClose": 210.25,
//         "volume": 38492128,
//         "unadjustedVolume": 38492128,
//         "change": -1.2,
//         "changePercent": -0.56751,
//         "vwap": 210.62,
//         "label": "May 14, 25",
//         "changeOverTime": -0.0056751
//       },
//       {
//         "date": "2025-05-13",
//         "open": 211.08,
//         "high": 214.84,
//         "low": 210.1,
//         "close": 211.37,
//         "adjClose": 211.37,
//         "volume": 56193700,
//         "unadjustedVolume": 56193700,
//         "change": 0.29,
//         "changePercent": 0.13739,
//         "vwap": 211.8475,
//         "label": "May 13, 25",
//         "changeOverTime": 0.0013739
//       },
//       {
//         "date": "2025-05-12",
//         "open": 210.71,
//         "high": 211.66,
//         "low": 205.75,
//         "close": 208.64,
//         "adjClose": 208.64,
//         "volume": 75205042,
//         "unadjustedVolume": 75205042,
//         "change": -2.07,
//         "changePercent": -0.98239,
//         "vwap": 209.19,
//         "label": "May 12, 25",
//         "changeOverTime": -0.0098239
//       },
//       {
//         "date": "2025-05-09",
//         "open": 193.38,
//         "high": 194.69,
//         "low": 191.16,
//         "close": 193.06,
//         "adjClose": 193.06,
//         "volume": 29663143,
//         "unadjustedVolume": 29663143,
//         "change": -0.315,
//         "changePercent": -0.16548,
//         "vwap": 193.0725,
//         "label": "May 09, 25",
//         "changeOverTime": -0.0016548
//       },
//       {
//         "date": "2025-05-08",
//         "open": 191.43,
//         "high": 194.33,
//         "low": 188.82,
//         "close": 192.08,
//         "adjClose": 192.08,
//         "volume": 41043620,
//         "unadjustedVolume": 41043620,
//         "change": 0.65,
//         "changePercent": 0.33955,
//         "vwap": 191.665,
//         "label": "May 08, 25",
//         "changeOverTime": 0.0033955
//       },
//       {
//         "date": "2025-05-07",
//         "open": 185.56,
//         "high": 190.99,
//         "low": 185.01,
//         "close": 188.71,
//         "adjClose": 188.71,
//         "volume": 44002926,
//         "unadjustedVolume": 44002926,
//         "change": 3.15,
//         "changePercent": 1.7,
//         "vwap": 187.5675,
//         "label": "May 07, 25",
//         "changeOverTime": 0.017
//       },
//       {
//         "date": "2025-05-06",
//         "open": 184.57,
//         "high": 187.93,
//         "low": 183.85,
//         "close": 185.01,
//         "adjClose": 185.01,
//         "volume": 29314100,
//         "unadjustedVolume": 29314100,
//         "change": 0.44,
//         "changePercent": 0.23839,
//         "vwap": 185.34,
//         "label": "May 06, 25",
//         "changeOverTime": 0.0023839
//       },
//       {
//         "date": "2025-05-05",
//         "open": 186.51,
//         "high": 188.18,
//         "low": 185.53,
//         "close": 186.35,
//         "adjClose": 186.35,
//         "volume": 35217500,
//         "unadjustedVolume": 35217500,
//         "change": -0.16,
//         "changePercent": -0.08578628,
//         "vwap": 186.6425,
//         "label": "May 05, 25",
//         "changeOverTime": -0.0008578628
//       },
//       {
//         "date": "2025-05-02",
//         "open": 191.44,
//         "high": 192.88,
//         "low": 186.4,
//         "close": 189.98,
//         "adjClose": 189.98,
//         "volume": 77903500,
//         "unadjustedVolume": 77903500,
//         "change": -1.46,
//         "changePercent": -0.76264,
//         "vwap": 190.175,
//         "label": "May 02, 25",
//         "changeOverTime": -0.0076264
//       },
//       {
//         "date": "2025-05-01",
//         "open": 190.63,
//         "high": 191.81,
//         "low": 187.5,
//         "close": 190.2,
//         "adjClose": 190.2,
//         "volume": 74266000,
//         "unadjustedVolume": 74266000,
//         "change": -0.43,
//         "changePercent": -0.22557,
//         "vwap": 190.035,
//         "label": "May 01, 25",
//         "changeOverTime": -0.0022557
//       }
//     ]
//   }
// };

// New function that returns mock historical data
// export const fetchHistoricalData = async (symbol) => {
//   try {
//     // Simulate network delay
//     await new Promise(resolve => setTimeout(resolve, 500));
    
//     // Check if the symbol exists in our mock data
//     if (MOCK_HISTORICAL_DATA[symbol]) {
//       // Create a response object similar to the API response
//       const mockResponse = {
//         symbol: symbol,
//         historical: MOCK_HISTORICAL_DATA[symbol].historical
//       };
      
//       console.log("***Historical Data Response:", mockResponse); // Match the log format exactly
      
//       // Return just the historical array to match the original function
//       return mockResponse.historical || [];
//     } else {
//       // If symbol not found in mock data
//       console.error("Symbol not found in mock historical data:", symbol);
//       return []; // Return empty array to match error case in original function
//     }
//   } catch (error) {
//     console.error("Error fetching mock historical data:", error);
//     return []; // Return empty array to match error case in original function
//   }
// };

// For ratios WIP
// export async function fetchStockRatios(ticker) {
//   const response = await fetch(`https://your-api.com/ratios?ticker=${ticker}`);
//   if (!response.ok) throw new Error('Failed to fetch stock ratios');
//   return response.json(); 
// }

// export async function fetchStockRatios(ticker) {
//   const response = await fetch(`https://1azyop0jo8.execute-api.eu-west-2.amazonaws.com/dev/public-fmp-metrics?symbol=${ticker}`);
//   if (!response.ok) throw new Error('Failed to fetch stock ratios');
//   return response.json();
// }

// export async function fetchPublicFmpMetrics(symbol) {
//   const res = await fetch(`https://1azyop0jo8.execute-api.eu-west-2.amazonaws.com/dev/public-fmp-metrics?symbol=${symbol}`);
//   if (!res.ok) throw new Error('Failed to fetch public metrics');
//   return res.json();
// }


//  export const fetchPublicFmpMetrics = async (symbol, type = 'ratios') => {

//      const res = await fetch(
//       //  `https://1azyop0jo8.execute-api.eu-west-2.amazonaws.com/dev/public-fmp-metrics?symbol=${symbol}&type=${type}`
//       `https://d1imbma6yo5wmc.cloudfront.net/public-fmp-metrics?symbol=${symbol}&type=${type}`
//      );


//      if (!res.ok) throw new Error(`Failed to fetch ${type} data`);
//      return res.json();
//    };
  
export const fetchPublicFmpMetrics = async (symbol, type = 'ratios') => {
  // const url = `https://d1imbma6yo5wmc.cloudfront.net/public-fmp-metrics?symbol=${symbol}&type=${type}`;
   // >>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>>>>>
   const url = `/public-fmp-metrics?symbol=${symbol}&type=${type}`;
   // <<<<<<<<<<<<<<<<<<<<<<< Code to add <<<<<<<<<<<
 
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(`Failed to fetch ${type} data for ${symbol}`);
  }

  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (err) {
    console.error(`Invalid JSON for ${symbol}:`, text.slice(0, 200));
    throw new Error(`Response for ${symbol} is not valid JSON`);
  }
};

  //  export const fetchHistoricalData = (symbol) =>
  //    fetchPublicFmpMetrics(symbol, 'historical').then((data) => data.historical || []);

  export const fetchHistoricalData = (symbol) =>
  fetchPublicFmpMetrics(symbol, 'historical').then((data) => {
    // New FMP stable endpoint returns a plain array:
    // [ { symbol, date, open, high, low, close, volume, vwap, changePercent }, ... ]
    if (Array.isArray(data)) {
      return data;
    }

    // Backward-compatibility in case the backend ever wraps it:
    if (data && Array.isArray(data.historical)) {
      return data.historical;
    }

    console.error('Unexpected historical data shape:', data);
    return [];
  });
  
   export const fetchMetrics = (symbol) =>
     fetchPublicFmpMetrics(symbol, 'ratios').then((data) => data?.[0] || null);


     